import { render } from "./MacroEcon.vue?vue&type=template&id=81e1f5ae&scoped=true"
import script from "./MacroEcon.vue?vue&type=script&lang=js"
export * from "./MacroEcon.vue?vue&type=script&lang=js"

import "./MacroEcon.vue?vue&type=style&index=0&id=81e1f5ae&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81e1f5ae"]])

export default __exports__